import React, { useMemo } from "react";
import { useData } from "../../context/DataContext";
import { useAuth } from "../../context/AuthContext";
import { userMatchesField, cellText } from "../../utils/helpers";
import TaskTable from "../../components/TaskTable";
import { USER_TABLE } from "../../context/DataContext";

export default function CompletedTasks() {
  const { userRecords, loading } = useData();
  const { user } = useAuth();

  const completed = useMemo(() =>
    userRecords.filter((r) => {
      const isMine = r.user_id === user?.userId;
      if (!isMine) return false;
      return r.fields?.["My Completion"];
    }),
    [userRecords, user]
  );

  if (loading && userRecords.length === 0) return <div className="loading-box"><div className="spinner" /><span>Loading...</span></div>;

  return (
    <div className="fade-in">
      <div className="page-header">
        <h1>✅ Completed Tasks</h1>
        <p>Tasks you have successfully completed — {completed.length} records</p>
      </div>
      <TaskTable 
        tableId={USER_TABLE} 
        records={completed} 
        emptyMsg="No completed tasks yet. Keep going! 💪" 
        statusOptionsOverride={["✅ Done", "🔴 Overdue (Done)"]}
      />
    </div>
  );
}
